import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RebirthHttpProvider } from 'rebirth-http';
import { LoginService } from '../services/login.service';
import { DefaultGlobalInterceptor } from 'src/app/shared-resources/interceptors/default-global.interceptor';
import { I18nClientService } from 'src/app/shared-resources/base-i18n/services/i18n-client.service';
import { EnvironmentService } from 'src/app/shared-resources/services/environment.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';

@Component({
  selector: 'app-mobile-bypass',
  templateUrl: './mobile-bypass.component.html',
  styleUrls: ['./mobile-bypass.component.less'],
})
export class MobileBypassComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private rebirthHttpProvider: RebirthHttpProvider,
    private defaultInterceptor: DefaultGlobalInterceptor,
    private i18nService: I18nClientService,
    private envService: EnvironmentService,
    private loginService: LoginService,
    private userService: UserInfoService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.load(params);
    });
  }

  load(params: any): void {
    this.userService.setUserToken(params['token']);
    this.userService.setUserName(params['userName']);
    this.userService.setUserType(params['userType']);
    const jsonFile = `assets/config/environment.json`;
    this.http.get(jsonFile).subscribe(
      (response: any) => {
        environment.baseUrl = response.baseUrl;
        this.rebirthHttpProvider
          .baseUrl(response.baseUrl)
          .addInterceptor(this.defaultInterceptor);
        this.envService.setEnvironment(environment);
        this.i18nService.loadResource();
        if (this.loginService.isAuthenticated()) {
          this.loginService
            .userDetails({ username: this.userService.getUserName() })
            .subscribe((res: any) => {
              this.loginService.setUserData(
                res,
                this.userService.getUserName()
              );
              this.router.navigateByUrl('/app/landing');
            });
        }
        if (environment.botEnable) this.addChatBot();
      },
      () => {
        this.router.navigateByUrl('/login');
      }
    );
  }

  addChatBot(): void {
    // Bot integration start
    const script = document.createElement('script');
    script.src =
      environment.baseUrl + '/botpress/assets/modules/channel-web/inject.js';
    // script.src = "http://localhost:3000/assets/modules/channel-web/inject.js";
    document.head.appendChild(script);

    setTimeout(() => {
      const scriptBot = document.createElement('script');
      scriptBot.textContent =
        "window.botpressWebChat.init({ host: '" +
        environment.baseUrl +
        "/botpress', botId: 'cargoes' })";
      // scriptBot.textContent = "window.botpressWebChat.init({ host: 'http://localhost:3000', botId: 'riise-bot' })";
      document.body.append(scriptBot);
    }, 3000);
    // Bot integration end
  }
}
